import Inputmask from 'inputmask';

export default {
    finalize() {
        window.addEventListener('load', function () {
            const inputMask = new Inputmask('999-999-9999');
            const contactPhone = document.getElementById('nf-field-7');

            inputMask.mask(contactPhone);
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js